import store from "../store";

// Importación de Axios
import axios from "axios";
import { RUTA_SERVIDOR_BACKEND } from "./configuraciones";

//Tracking details
export const getTrackingDetails = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/tracking/getTrackingDetails`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }).then(({ data }) => {

    dataAux = data;

  }).catch((e) => {

    console.log("Error: " + e);

  });

  return dataAux;

};

/*Buscar BL*/
export const buscarBillLadings = async (data) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/buscarBillLading`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => {
      dataAux = data;
    }).catch((e) => {
      console.log("Error: " + e);
    });
  return dataAux;
}
/*
Sección Bookings - Ver mis booking por aceptar
*/
export const getVerMisBookingsPorAceptar = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarBookingsPorAceptar`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
//bookings por aceptar filtro
export const getVerMisBookingsPorAceptarFiltrados = async (filters) => {
  store.state.cargarTabla = true;
  let dataAux = new Array();

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/listarBookingsPorAceptar`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => {
      dataAux = data.data_table;
      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    });
  return dataAux;
}
export const updateBookingsPorAceptar = async () => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/editarBookingsPorAceptar`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });
  dataAux.push({ error: estadoResponse, data: dataResponse });
  return dataAux[0];
};

export const deleteBookingsPorAceptar = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarBookingPorAceptar/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const enviarMailVerMisBookingsPorAceptar = (id_booking, id_country) =>
  axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/enviarMailVerMisBookingsPorAceptar/${id_booking}/${id_country}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const sendEmailsContactosClientesPorBookingId = (idBooking, porAceptar, bookingItineraryId) =>
  axios.get(
    `${RUTA_SERVIDOR_BACKEND}/sendEmailsContactosClientesPorBookingId/${idBooking}/${porAceptar}${bookingItineraryId ? "/" + bookingItineraryId : ""}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  )
    .then(({ data }) => data);

export const sendEmailsSolicitudModificacion = async (payload) => {
  const result = await axios.post(`${RUTA_SERVIDOR_BACKEND}/sendEmailsSolicitudModificacion`,
    payload,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return result;
}
/*  

Sección Bookings - Bookings por confirmar

*/

export const getBookingsPorConfirmar = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/bookingsPorConfirmar`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
//bookings por aceptar filtro
export const getBookingsPorConfirmarFiltrados = async (filters) => {
  store.state.cargarTabla = true;
  let dataAux = new Array();

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/bookingsPorConfirmar`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => {
      dataAux = data.data_table;
      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    });
  return dataAux;
}
// Ver Historial Acciones Confirmados
export const getHistorialBookingPorConfirmar = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/verHistorialBookingPorConfirmar/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
// Cancelar Booking Por Confirmar
export const cancelarBookingPorConfirmar = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/cancelarBookingPorConfirmar`,
      {
        id_booking: data.id,
        booking_itinerary_id: data.booking_itinerary_id,
        cantidad: data.cantidadModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/*  

Sección Bookings - BookingsConfirmados Cliente

*/

export const getBookingsConfirmadosCliente = async () => {
  store.state.cargarTabla = true;
  let dataAux = new Array();
  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarBookingsConfirmados`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    });
  return dataAux;
};
//filtro bookkings declarados
export const getBookingsConfirmadosClienteFiltrados = async (filters) => {
  store.state.cargarTabla = true;
  let dataAux = new Array();

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/listarBookingsConfirmados`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => {
      dataAux = data.data_table;
      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    });
  return dataAux;
}
// Embarcar Booking
export const embarcarBookingConfirmado = async (data, tipo) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/embarcarBooking`,

      {
        data,
        tipo
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Ver Historial Acciones Confirmados
export const getHistorialBookingConfirmados = (id, booking_itinerary_id) =>
  axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/verHistorialBookingConfirmado/${id}/${booking_itinerary_id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);
// Editar Booking Confirmado
export const updateBookingsConfirmados = async () => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  await axios
    .put(`${RUTA_SERVIDOR_BACKEND}/editarBookingsConfirmados`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateBlNumber = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/updateBlNumber`,data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};


// Eliminar Booking Confirmado
export const deleteBookingsConfirmados = async (data, tipo) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/cancelarBookingConfirmado`,
      {
        data,
        tipo
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Enviar notificaciones de bookings
export const notificarBookingsConfirmados = async () => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/enviarCorreoConfirmados`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const downloadReporteBookingsConfirmados = async (data, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/reporteBookingsConfirmados`,
    {
      filters: data
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

/*Sección Bookings - Solicitudes de Modificacion

    */
// Solicitud de Modificacion
export const getBookingsSolicitudesModificacion = async () => {
  store.state.cargarTabla = true;
  let dataAux = new Array();
  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarSolicitudesDeModificacion`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;

      // store.state.loadingTable = true;

      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    })
    .catch((e) => {
      // Podemos mostrar los errores en la consola
      console.log(e);
    });

  return dataAux;
};

//filtro solicitudes de moficiacion
export const getBookingsSolicitudesModificacionFiltradas = async (filters) => {
  store.state.cargarTabla = true;
  let dataAux = new Array();
  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarSolicitudesDeModificacion`,
      {
        filters: filters
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => {
      dataAux = data.data_table;
      store.state.loadingTable = true;
      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    }).catch((e) => {
      console.log(e);
    });
  return dataAux;
};

// Actualizar Solicitud de Modificacion
export const updateBookingsSolicitudesModificacion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/editarSolicitudDeModificacion`,
      {
        id: data.id,
        motivo: data.motivo.id,
        detalle: data.detalle,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Eliminado Logico
export const deleteSolicitudModificacion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(
      `${RUTA_SERVIDOR_BACKEND}/eliminarSolicitudDeModificacion/${data.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const getHistorialSolicitudesModificacion = async () => {
  store.state.cargarTabla = true;
  let dataAux = new Array();
  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/verHistorialSolicitudesModificacion`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;

      // store.state.loadingTable = true;

      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    })
    .catch((e) => {
      // Podemos mostrar los errores en la consola
      console.log(e);
    });

  return dataAux;
};

//historial sol. mod. filtradas
export const getHistorialSolicitudesModificacionFiltrado = async (filters) => {
  store.state.cargarTabla = true;
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/verHistorialSolicitudesModificacion`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  ).then(({ data }) => {
    dataAux = data.data_table;
    setTimeout(() => {
      store.state.cargarTabla = false;
    }, 800);
  }).catch((e) => {
    console.log(e);
  });
  return dataAux;
};
// Fin Solicitud de Modificacion

// Embarcados

export const getBookingsEmbarcados = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarBookingsEmbarcados`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
//bookings embarcados filtrados
export const getBookingsEmbarcadosFiltrados = async (filters) => {
  let dataAux = new Array();
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarBookingsEmbarcados`,
      {
        filters: filters,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataAux = data.data_table;
    }).catch((e) => {
      console.log(e)
    });
  return dataAux;
};
// Actualizar Booking Embarcado
export const updateBookingEmbarcado = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarBookingEmbarcado`,
      {
        id: data.id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// Eliminar Booking Embarcado
export const deleteBookingEmbarcado = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/eliminarBookingEmbarcado`,
      {
        id_booking: data.id_booking,
        booking_itinerary_id: data.booking_itinerary_id,
        cantidad: data.cantidadModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Ver Historial Acciones Embarcado
export const getHistorialBookingEmbarcado = (id, idItineraryModel) =>
  axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/verHistorialBookingEmbarcado/${id}/${idItineraryModel}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);
// PDF Booking Embarcado
export const bookingsEmbarcadosUploadPdf = async (file) => {
  var dataForm = new FormData();

  dataForm.append("file", file);

  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/bookingsEmbarcadosUploadPdf`, dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(
      () => {
        //if success
        console.log("Todo Ok");
        // console.log(response);
      },
      (response) => {
        //if error occures
        console.log(response);
      }
    );
};

export const downloadReporteBookingsEmbarcados = async (data, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/reporteBookingsEmbarcados`,
    {
      filters: data
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

// Fin Embarcados

// Cancelados
export const getBookingsCancelados = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarBookingsCancelados`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
//filtro bookings cancelados
export const getBookingsCanceladosFiltrados = async (filters) => {
  store.state.cargarTabla = true;
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/listarBookingsCancelados`,
    { filters: filters },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data.data_table;
      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    });
  return dataAux;
};
// Historial Booking Cancelado
export const getHistorialBookingsCancelados = (id, booking_itinerary_id) =>
  axios

    .get(
      `${RUTA_SERVIDOR_BACKEND}/verHistorialBookingCancelado/${id}/${booking_itinerary_id}`,

      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const reactivarBookingCancelados = async (id) => {

  let dataResponse, estadoResponse, dataAux = [];

  await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/reactivarBookingCancelado`,
    {
      booking_itinerary_id: id,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  ).then(function ({ status }) {

    dataResponse = status;

    estadoResponse = false;

  }).catch(({ response }) => {

    dataResponse = response.data;

    estadoResponse = true;

  });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// Fin Cancelados

// Declarados Cancelados
export const getBookingsDeclaradosCancelados = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarBookingsDeclaradosCancelados`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
//bookings declarados cancelados
export const getBookingsDeclaradosCanceladosFiltrados = async (filters) => {
  store.state.cargarTabla = true;
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/listarBookingsDeclaradosCancelados`,
    { filters: filters },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data.data_table;
      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    });
  return dataAux;
};
// Historial Booking Declarado Cancelado
export const getHistorialBookingsDeclaradosCancelados = (id) =>
  axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/verHistorialBookingDeclaradoCancelado/${id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const reactivarBookingDeclaradosCancelados = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  // console.log(data);
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/reactivarBookingDeclaradoCancelado`,
      {
        booking_id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const downloadReporteBookingsDeclarados = async (data, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/reporteBookingsDeclarados`,
    {
      filters: data
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};
// export const reactivarBookingDeclaradosCancelados = (id) =>
//   axios
//     .post(`${RUTA_SERVIDOR_BACKEND}/reactivarBookingDeclaradoCancelado/${id}`, {
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     })
//     .then(({ data }) => data);

// Fin Declarados Cancelados

// Perfil Administrador

// Bookings Solicitados
export const getBookingsSolicitados = async () => {
  store.state.cargarTabla = true;
  let dataAux = new Array();
  // let dataAux;
  // store.state.loadingT= true;

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarBookingsSolicitados`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 800);
    });

  return dataAux;
};

export const getGeneralLineas = async () => {

  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/generalReport`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => {
      dataAux = data;
    });

  return dataAux;

};

// export const actualizarReporteGeneral = async () => {

//   let dataAux = new Array();

//   await axios
//     .get(`${RUTA_SERVIDOR_BACKEND}/exportGeneralReport`, {
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     }).then(({ data }) => {
//       dataAux = data;
//     });

//   return dataAux;
// }


export const exportGeneralReport = async (filters) =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/generateGeneralReport`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => data);

//Filtrar bookings solicitados
export const getBookingsSolicitadosFiltrados = async (filters) => {
  //store.state.cargarTabla = true;
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/listarBookingsSolicitados`,
    { filters: filters },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data.data_table;
      // setTimeout(() => {
      //   store.state.cargarTabla = false;
      // }, 800);
    });
  return dataAux;
};
// Guardar Booking
export const saveBookingSolicitado = async (data, tipo) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/guardarBookingSolicitado`,
      {
        data,
        tipo
      },

      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// Ver Historial Acciones Solicitados
export const getHistorialBookingsSolicitados = (id, idBookingItinerary) =>
  axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/verHistorialBookingSolicitados/${id}/${idBookingItinerary}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);
// Eliminar Booking Solicitado
export const deleteBookingSolicitado = async (data, tipo) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/cancelarBookingSolicitado`,
      {
        // booking_id: data.id_booking,
        // booking_itinerary_id: data.booking_itinerary_id,
        // cantidad: data.cantidadModel,
        data,
        tipo
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const downloadReporteBookingsSolicitados = async (data, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/reporteBookingsSolicitados`,
    {
      filters: data
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

// Bookings Declarados
export const getBookingsDeclarados = async () => {
  // let dataAux;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarBookingsDeclarados`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;

      store.state.cargarTabla = false;

      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 400);
    })
    .catch((e) => {
      // Podemos mostrar los errores en la consola
      console.log(e);
    });

  return dataAux;
};
//bookings declarados filtrados
export const getBookingsDeclaradosFiltrados = async (filters) => {
  // let dataAux;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarBookingsDeclarados`,
      {
        filters: filters
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => {
      dataAux = data.data_table;

      store.state.cargarTabla = false;

      setTimeout(() => {
        store.state.cargarTabla = false;
      }, 400);
    })
    .catch((e) => {
      // Podemos mostrar los errores en la consola
      console.log(e);
    });

  return dataAux;
};
// Ver Historial Acciones Declarados
export const getHistorialBookingsDeclarados = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/verHistorialBookingDeclarado/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Eliminar Booking Declarado
export const deleteBookingDeclarado = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarBookingDeclarado/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Tarifas

export const getAllContracts = async () => {
  const result = axios.get(`${RUTA_SERVIDOR_BACKEND}/getAllContracts`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return result;
}

export const getContratosTarifas = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarContratos`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getContratosTarifasFiltros = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarContratosFiltros`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Crear Contrato
export const crearContrato = async data => await axios
  .post(
    `${RUTA_SERVIDOR_BACKEND}/crearContrato`, {
    type: data.tipoModel.id,
    name: data.nombreModel,
    client_id: data.clienteModel.id,
    naviera_id: data.navieraModel.id,
    start: data.vigenciaInicioModel,
    end: data.vigenciaTerminoModel,
    number: data.numeroModel,
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }
  );

// Actualizar Contrato
export const updateContratos = async data => await axios
  .put(
    `${RUTA_SERVIDOR_BACKEND}/actualizarContrato`, {
    id: data.id ?? null,
    type: data.tipoModel.id ?? null,
    name: data.nombreModel ?? "",
    client_id: data.clienteModel.id ?? null,
    naviera_id: data.navieraModel.id ?? null,
    start: data.vigenciaInicioModel ?? "",
    end: data.vigenciaTerminoModel ?? "",
    number: data.numeroModel ?? "",
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }
  );

// Eliminar Contrato
export const deleteContrato = async (id) => {

  let data;

  await axios.delete(`${RUTA_SERVIDOR_BACKEND}/eliminarContrato/${id}`, {

    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }

  }).then(response => {

    data = response.data;

  });

  return data;

};

// Acuerdos Lineas

export const getAllAcuerdosLineas = () => {
  const result = axios.get(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosLineas`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return result;
}

export const getAcuerdosLineas = () => {

  const form = store.state.lineas.filterStateAcuerdosLineas;

  return form !== null
    ? axios.post(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosLineas`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then(({ data }) => data)

    : axios.get(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosLineas`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then(({ data }) => data);
}


// Acuerdos Lineas
export const getAcuerdosLineasFiltros = (form) =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosLineas`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);


export const getPODByDestination = (data) =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/getPODByDestination`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => data);

// Crear Contrato
export const crearAcuerdoLinea = async (form) => {
  let dataResponse;
  let estadoResponse;
  let ids;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/crearAcuerdoLinea`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status, data }) {
      dataResponse = status;
      estadoResponse = false;
      ids = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse, created: ids });

  return dataAux[0];
};
// Actualizar Contrato
export const updateAcuerdoLineas = async (form) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(`${RUTA_SERVIDOR_BACKEND}/editarAcuerdoLinea`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// Eliminar Acuerdo de Lineas
export const deleteAcuerdoLinea = async (data) => {

  const result = await axios.delete(`${RUTA_SERVIDOR_BACKEND}/eliminarAcuerdoLinea/${data.id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return result;

};
// Eliminar Acuerdo de Lineas masivo
export const deleteManyTariffLines = async (payload) => {

  const result = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/deleteManyTariffLines`,
    { idsSelected: payload },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

  return result.data;

};
// Acuerdos Clientes
export const getAcuerdosClientes = () => {
  const form = store.state.lineas.filterStateAcuerdosClientes;

  return form !== null
    ? axios.post(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosClientes`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => data)

    : axios.get(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosClientes`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => data)
}

export const getAcuerdosClientesFiltros = (form) =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosClientes`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);


// cargarContratosPorNavieraYTipo
export const getContratosPorNavieraYTipo = async (data) => {
  let dataResponse;
  let dataAux = new Array();

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/cargarContratosPorNavieraYTipo`,
    {
      naviera_id: data.naviera_id ?? null,
      type: data.type,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      dataResponse = data;
      setInterval(() => { }, 700);
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);
  return dataAux[0];
}

export const getRecargos = () => {
  const form = store.state.lineas.filterStateRecargos;

  return form !== null
    ? axios.post(`${RUTA_SERVIDOR_BACKEND}/listarRecargos`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => data)
    : axios.get(`${RUTA_SERVIDOR_BACKEND}/listarRecargos`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => data);
};


export const getSelectsRecargos = () => axios
  .get(`${RUTA_SERVIDOR_BACKEND}/getSelectsRecargos`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const asignarTarifasRecargos = async (payload) => {
  const result = await axios.post(`${RUTA_SERVIDOR_BACKEND}/asignarTarifasRecargos`, payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return result;
}

export const eliminarAsignacionTarifasRecargos = async data  => {
  const result = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/eliminarAsignacionTarifasRecargos`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return result;
}
export const eliminarAsignacionTarifasRecargosPorTarifa = async (id) => {
  const result = await axios.delete(`${RUTA_SERVIDOR_BACKEND}/eliminarAsignacionTarifasRecargosPorTarifa/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return result;
}
export const verRecargosPorTarifa = async id => {
  const { data } = await axios.get(`${RUTA_SERVIDOR_BACKEND}/verRecargosPorTarifa/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return data;
}

export const getClientDiscountRecharges = async id => {
  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/customerDiscounts/getRechargesByTariffID`,
    { id: id },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
  return data;
};

export const getTariffLinesRecharges = async id => {
  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/tariffLine/getRechargesByTariffID`,
    { id: id },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
  return data;
};

// Acuerdos Clientes Base

export const getClients = async () => {
  const result = await axios.get(`${RUTA_SERVIDOR_BACKEND}/getClients`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return result
}

export const getAcuerdosClientesBase = () => {

  const form = store.state.lineas.filterStateAcuerdosClientesBase;

  return form !== null
    ? axios.post(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosClienteBase`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => data)

    : axios.get(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosClienteBase`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => data);
}

export const getListasAcuerdosBase = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/enviarListas`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getAcuerdosClientesBaseByIds = (ids) =>
  axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/listarAcuerdosClienteBase?ids_multiple=${ids.join()}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const getAcuerdosClientesBaseFiltro = (form) =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosClienteBase`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const listarTariffClientRecords = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarTariffClientRecords/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const editarAcuerdoBaseClientes = (form) =>
  axios
    .put(`${RUTA_SERVIDOR_BACKEND}/editarAcuerdoBaseClientes`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const findTariffsLines = form =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/findTariffsLines`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(({ data }) => data);

export const generateTariffClients = form =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/generateTariffClients`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(({ data }) => data);

// Eliminar Acuerdo Clientes Base
export const deleteAcuerdosClientesBase = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(
      `${RUTA_SERVIDOR_BACKEND}/eliminarAcuerdosClientesBase/${data.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteManyAcuerdosClienteBase = (form) =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/deleteManyAcuerdosClienteBase`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const publicarDespublicarAcuerdosClientes = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/publicarDespublicarAcuerdosClientes`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const publicarDespublicarAcuerdosClientesByBooleano = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/publicarDespublicarAcuerdosClientesByBooleano`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const aplicarMargen = (form) =>
  axios
    .put(`${RUTA_SERVIDOR_BACKEND}/aplicarMargen`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const deleteManyAcuerdosCliente = async (form) => {

  let data;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/deleteManyAcuerdosCliente`, form, {

    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }

  }).then(response => {

    data = response.data;

  });

  return data;

};


// Tarifas Lineas
export const getTarifasLineas = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarTarifasLineas`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getTarifasLineasFiltro = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarTarifasLineas`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const generarReporteTarifasLineas = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/reporteTarifasLineas`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const publicarDespublicarAcuerdosClienteBase = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/publicarDespublicarAcuerdosClienteBase`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

// Descuentos Clientes
export const getDescuentosClientes = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarDescuentosClientes`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getDescuentosClientesFiltros = (form) =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarDescuentosClientes`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const downloadReporteDescuentosClientes = async (data) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/reporteDescuentosClientes`,
    {
      filters: data
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }).then((response) => {
        console.log(response);
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

//Reporte Tarifa Embarcador

export const generarReporteTarifaEmbarcador = async (payload) => {
  const result = await axios.post(`${RUTA_SERVIDOR_BACKEND}/generarReporteTarifaEmbarcador`, payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return result;
}

export const generarReporteFinanzasLineas = async (data) => {

  const response = await axios.post(`${RUTA_SERVIDOR_BACKEND}/finances/report`,
    data,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
  return response.data;
};


// export const getListarServiciosAceptarBookingDeclarado = (id) =>
//   axios
//     .get(`${RUTA_SERVIDOR_BACKEND}/listarServiciosAceptarBookingDeclarado`, {
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     })
//     .then(({ data }) => data);

/*Sección Late Arrivals 

    */
export const getBookingsLateArrivals = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarLateArrivals`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
//LateArrivals filtrados
export const getBookingsLateArrivalsFiltrados = async (filters) => {
  //store.state.cargarTabla = true;
  let dataAux = new Array();

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/listarLateArrivals`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => {
      dataAux = data.data_table;
      // setTimeout(() => {
      //   store.state.cargarTabla = false;
      // }, 800);
    });
  return dataAux;
}
// Listar Late Por Itinerario para Actualizar -- mostrar modal con tabla y listar nro de contenedores por booking_itinerary_id
export const getLateArrivalsPorItinerario = (id) =>
  axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/listarLateArrivalsPorBookingItinerario/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const deleteBookingsLateArrivals = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarLateArrival/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// Historial Late Arrivals
export const getHistorialLateArrivals = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/verHistorialLateArrival/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getListarDetalleLateArrivals = (id) =>
  axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/listarDetalleLateArrivalsPorBookingItinerario/${id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

/*Sección Servicios 

    */

export const getServicios = async () => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  store.state.loadingTable = true;

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarServicios`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      store.state.loadingTable = false;
      dataResponse = data;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      store.state.loadingTable = false;
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });
  return dataAux[0];
};

export const getServiciosFiltros = async form => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarServicios`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      dataResponse = data;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });
  return dataAux[0];
};

export const getServiciosDetalles = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  store.state.loadingTableModal = true;

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/verDetalleServicio/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })

    .then(function ({ data }) {
      store.state.loadingTableModal = false;
      dataResponse = data;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      store.state.loadingTableModal = false;
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });
  return dataAux[0];
};

export const saveServicio = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearServicio`,
      {
        name: data.nombreModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateServicio = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/editarServicio`,
      {
        id: data.id,
        name: data.nombreModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deshabilitarServicio = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarServicio`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const getServiciosPuertos = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  store.state.loadingTableModal = true;

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarPuertosPorServicio/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      store.state.loadingTableModal = false;
      store.state.loadingServiciosPuertos = false;
      dataResponse = data;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      store.state.loadingTableModal = false;
      store.state.loadingServiciosPuertos = false;
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const saveServiciosPuertos = async (form) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/crearPuertoServicio`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateServiciosPuertos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/editarPuertoServicio`,
      {
        id_route: data.id_route,
        id_port: data.id_port,
        tt_reefer: data.TTReeferModel,
        tt_dry: data.TTDryModel,
        nombreServicio: data.nombreServicio,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteServiciosPuertos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/eliminarPuertoServicio`,
      {
        id_puerto: data.id_puerto,
        id_servicio: data.id_servicio,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// export const getServiciosTransbordos = async (id) => {
//   const { data } = await axios.get(
//     `${RUTA_SERVIDOR_BACKEND}/listarTransbordosPorServicio/${id}`,
//     {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     }
//   );
//   return data;
// };

export const getServiciosTransbordos = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarTransbordosPorServicio/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      store.state.loadingServiciosTransbordos = false;
      dataResponse = data;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      store.state.loadingServiciosTransbordos = false;
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const saveServiciosTransbordos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearTransbordoServicio`,
      {
        route_id: data.id,
        name: data.nombreTransbordoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateServiciosTransbordos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/editarTransbordo`,
      {
        id: data.id,
        name: data.nombreTransbordoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteServiciosTransbordos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarTransbordoServicio/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Puertos
export const getServiciosTransbordosPuertos = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarPuertosTransbordo/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveServiciosTransbordosPuertos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearPuertoTransbordo`,
      {
        transfer_id: data.id,
        transfer_ports: data.puertoModel,
        tt_reefer: data.TTReeferModel,
        tt_dry: data.TTDryModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Transbordos
export const updateServiciosTransbordosPuertos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/editarPuertoTransbordo/${data.id}`,
      {
        id: data.id,
        tt_reefer: data.TTReeferModel,
        tt_dry: data.TTDryModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteServiciosTransbordosPuertos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarPuertoTransbordo/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/*Sección Itinerarios 

    */
export const getItinerarios = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarItinerarios`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);


// Filter
export const getItinerariosFilter = data =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarItinerarios`, {
      filters: data
    },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);




export const getItinerariosServiciosPuertosTransbordos = async (id) =>
  await axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/listarPuertosYTransbordosPorServicio/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const saveItinerario = async form => {

  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/crearItinerario`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};

export const updateItinerario = async form => {

  const { data } = await axios
    .put(`${RUTA_SERVIDOR_BACKEND}/itinerary`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

  return data;
};

export const deleteItinerario = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarItinerario/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })

    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const downloadReporteItinerario = async (data, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/reporteItinerarios`,
    data,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

// PUERTOS DE EMBARQUE
export const getItinerariosPuertos = async (id) =>
  await axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/listarPuertosDeEmbarquePorItinerario/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const saveItinerariosPuertosEmbarque = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  data.puertoModel = data.puertoModel.map((d) => {
    d.id_port = d.id;
    return d;
  });
  const form = {
    itinerary_id: data.id,
    chargins_port: data.puertoModel,
  };
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/agregarPuertosDeEmbarquePorItinerario`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateItinerariosPuertos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/editarPuertoServicio/${data.id}`,
      {
        id: data.id,
        tt_reefer: data.TTReeferModel,
        tt_dry: data.TTDryModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// Eliminar Puerto de Embarque
export const deleteItinerariosPuertosEmbarque = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(
      `${RUTA_SERVIDOR_BACKEND}/eliminarPuertosDeEmbarquePorItinerario/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// DESTINOS FINALES
// Obtener Destinos Finales Itinerarios
export const getItinerariosDestinosFinales = async (id) =>
  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarDestinosFinalesPorItinerario/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
// Guardar DestinosFinales
export const saveItinerariosDestinosFinales = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  data.puertoModel = data.puertoModel.map((d) => {
    d.id_port = d.id;
    return d;
  });

  const form = {
    itinerary_id: data.id,
    discharge_ports: data.puertoModel,
  };
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/agregarDestinosFinalesPorItinerario`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// Actualizar Destinos Finales
export const updateItinerariosDestinosFinales = async (form) => {
  const { data } = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/editarDestinosFinalesPorItinerario`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};
// Eliminar Destinos Finales
export const deleteItinerariosDestinosFinales = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(
      `${RUTA_SERVIDOR_BACKEND}/eliminarDestinosFinalesPorItinerario/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// Obtener Transbordos Itinerarios
export const getItinerariosTransbordos = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarTransbordosPorItinerario/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      store.state.loadingItinerariosTransbordos = false;
      dataResponse = data;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      store.state.loadingItinerariosTransbordos = false;
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0].data;
};
// Guardar Transbordos Itinerarios
export const saveItinerariosTransbordos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/agregarTransbordoPorItinerario`,
      {
        itinerary_id: data.id,
        name: data.nombreTransbordoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
// // Actualizar Transbordos Itinerarios
// export const updateItinerariosTransbordos = async (data) => {
//   let dataResponse;
//   let estadoResponse;
//   let dataAux = new Array();

//   await axios
//     .put(
//       `${RUTA_SERVIDOR_BACKEND}/editarTransbordoPorItinerario`,
//       {
//         id: data.id,
//         name: data.nombreTransbordoModel,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     )
//     .then(function ({ status }) {
//       dataResponse = status;
//       estadoResponse = false;
//     })

//     .catch(({ response }) => {
//       dataResponse = response.data;
//       estadoResponse = true;
//     });

//   dataAux.push({ error: estadoResponse, data: dataResponse });

//   return dataAux[0];
// };
// // Eliminar Transbordos Itinerarios
// export const deleteItinerariosTransbordos = async (data) => {
//   let dataResponse;
//   let estadoResponse;
//   let dataAux = new Array();

//   await axios
//     .delete(
//       `${RUTA_SERVIDOR_BACKEND}/eliminarTransbordoItinerario/${data.id}`,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     )
//     .then(function ({ status }) {
//       dataResponse = status;
//       estadoResponse = false;
//     })

//     .catch(({ response }) => {
//       dataResponse = response.data;
//       estadoResponse = true;
//     });

//   dataAux.push({ error: estadoResponse, data: dataResponse });

//   return dataAux[0];
// };
// TRANSBORDOS DE ITINERARIO
// export const listarPuertosTransbordoItinerario = async (tranferId) => {
//   const { data } = await axios.get(
//     `${RUTA_SERVIDOR_BACKEND}/listarPuertosTransbordoPorItinerario/${tranferId}`,
//     {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     }
//   );
//   return data.data;
// };
export const listarPuertosTransbordos = async (idTransbordo) => {
  const { data } = await axios.get(
    `${RUTA_SERVIDOR_BACKEND}/listarPuertoTransbordoPorItinerario/${idTransbordo}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data.data;
};

export const editarAgregarEliminarTransbordoItinerario = async (form) => {
  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/editarAgregarEliminarTransbordo`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data;
};
// Cambiar Nombre Transbordo Itinerario
export const editarNombreTransbordoItinerario = async (form) => {
  const { data } = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/editarNombreTransbordoItinerario`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data.status;
};
// Eliminar Transbordo Itinerario
export const eliminarTransbordoItinerario = async (id) => {
  const { data } = await axios.delete(
    `${RUTA_SERVIDOR_BACKEND}/eliminarTransbordoPorItinerario/${id}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};
// Busqueda Itinerarios
export const getBusquedaItinerarios = async (data) => {
  let dataResponse;
  let dataAux = new Array();
  store.state.loadingTable = true;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/resultadoBusquedaItinerario`,
      {
        id_ports: data.puertosBusquedaModel.map(p => p.id),
        anio: data.anioBusquedaModel.value,
        container_type: data.tipoCargaBusquedaModel,
        semana: data.numeroSemanaBusquedaModel.id,
        semanas_mas: data.semanaBusquedaModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
      setInterval(() => {
        store.state.loadingTable = false;
      }, 700);
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      store.state.loadingTable = false;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const getBusquedaItinerariosSinLoading = async form => {

  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/resultadoBusquedaItinerario`,
    {
      id_ports: form.puertosBusquedaModel.map(p => p.id),
      chargins_ports: form.puertosEmbarqueBusquedaModel.map(p => p.id),
      anio: form.anioBusquedaModel.value,
      container_type: form.tipoCargaBusquedaModel,
      semana: form.numeroSemanaBusquedaModel.id,
      semanas_mas: form.semanaBusquedaModel,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data;
};

// Booking

// Booking planificados
export const getBookingsPlanificados = async () => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/getBookingQuotas`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};


// Booking no planificados
export const getBookingsNoPlanificados = async () => {
  store.state.loadingTable = true;
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/bookingNoPlanificado`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
      store.state.loadingTable = false;
    });

  return dataAux;
};

export const getBookingsNoPlanificadosSinLoading = async () => {
  let dataAux = new Array();

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/bookingNoPlanificado`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
    });

  return dataAux;
};

export const saveReserva = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearBooking`,
      {
        year: data.year,
        week: data.week,
        containers_requested: data.containers_requested,
        container_id: data.container_id,
        port_discharge_id: data.port_discharge_id,
        port_load_id: data.port_load_id,
        port_origin_id: data.port_origin_id,
        port_destination_id: data.port_destination_id,
        id_client_product: data.id_client_product,
        emition_bl: data.emition_bl,
        contract: data.contract,
        contrato_booking: data.contrato_booking,
        comment: data.comment,
        tariff_contract_id: data.tariff_contract_id,
        has_si: data.has_si,
        si_type_id: data.si_type_id,
        vessel: data.vessel,
        voyage: data.voyage,
        shipper_address_id: data.shipper_address_id,
        shipper_consignee_id: data.shipper_consignee_id,
        shipper_notify_id: data.shipper_notify_id,
        payment_method: data.payment_method,
        id_client: data.id_client,
        haulage_movement_type: data.haulage_movement_type,
        haulage_cost: data.haulage_cost,
        lugarCarga: data.lugarCargaModel,
        fechaRetiro: data.fechaRetiroModel,
        haulage_rampla: data.haulage_rampla,
        packing: data.packingModel,
        direccionPacking: data.direccionPackingModel,
        id_transportista: data.transportistaModel,
        itinerary_id: data.itinerary_id,
        container_cold_treatment: data.container_cold_treatment,
        container_temperature: data.container_temperature,
        container_cbm_ventilation: data.container_cbm_ventilation,
        container_percent_ventilation: data.container_percent_ventilation,
        container_atmosphere_id: data.container_atmosphere_id,
        container_percent_co2: data.container_percent_co2,
        container_percent_o2: data.container_percent_o2,
        planned: data.planned,
        shipper_id: data.shipper_id
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, status: dataResponse });

  return dataAux[0];
};

export const obtenerNave = async (year, week, pod, type) => {
  let dataResponse;
  let dataAux = new Array();
  store.state.loadingTable = true;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/seleccionarNaveYViaje`,
      {
        week,
        year,
        port_destination_id: pod,
        container_type: type,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
      setInterval(() => {
        store.state.loadingTable = false;
      }, 700);
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      store.state.loadingTable = false;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const obtenerContrato = async (data) => {
  let dataResponse;
  let dataAux = new Array();
  // store.state.loadingTable = true;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarContratos`,
      {
        pol_etd: data.from_date,
        pol: data.pol,
        pod: data.pod,
        naviera_id: data.naviera_id,
        products_category_id: data.products_category_id,
        container_id: data.container_id,
        atmosphere_id: data.atmosphere_id,
        client_id: data.client_id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
      setInterval(() => { }, 700);
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const listaContratos = async (data) => {
  let dataResponse;
  let dataAux = new Array();
  // store.state.loadingTable = true;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarContratosSinClient`,
      {
        pol_etd: data.from_date,
        naviera_id: data.naviera_id,
        type: data.type,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
      setInterval(() => { }, 700);
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};
// Obtener Servicios Bookings Declarados
export const obtenerServiciosBookingDeclarado = async (id_booking, filtered = true) => {
  let dataResponse;
  let dataAux = [];

  await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/listarServiciosParaBooking`,
    {
      id_booking: id_booking,
      filtered: filtered
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
  ).then(function ({ data }) {
    dataResponse = data;
    store.state.loadingServiciosBooking = false;
    store.state.loadingTable = false;
  }).catch(({ response }) => {
    dataResponse = response.data;
    store.state.loadingServiciosBooking = false;
    store.state.loadingTable = false;
  });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Obtener Servicios Bookings Solicitados
export const obtenerServiciosBookingSolicitado = async (data) => {
  let dataResponse;
  let dataAux = new Array();
  store.state.loadingServiciosBooking = true;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarServiciosParaBooking`,
      {
        creacionBooking: data.creacionBooking,
        id_discharge_port: data.id_discharge_port,
        container_id: data.container_id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
      store.state.loadingServiciosBooking = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;

      store.state.loadingServiciosBooking = false;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Tarifas - Contratos
// export const getTarifasContratos = () =>
//   axios
//     .get(`${RUTA_SERVIDOR_BACKEND}/listarTarifasContratos`, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     })
//     .then(({ data }) => data);

// Asignar servicio Booking
export const asignarServicioBooking = async (data, booking_id) => {
  let dataResponse;
  let dataAux = new Array();
  store.state.loadingServiciosBooking = true;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/asignarServicioBooking`,
      {
        booking_id,
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Cambiar Servicio Booking
export const cambiarServicioBooking = async (form) => {
  let dataResponse;
  let dataAux = new Array();
  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/cambiarServicioBooking`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Obtención de Shippers
export const obtenerShippers = async (id_client) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/obtenerClientesyRelacionados`,
      {
        id_client,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Obtención de Refigeración por producto
export const obtenerProductosPorCliente = async (id_client) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/obtenerProductosPorCliente`,
      {
        id_client,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const obtenerBranches = async () => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/obtenerBranches`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Obtención de Refigeración por producto
export const obtenerRefigeracionProducto = async (id_product) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/obtenerRefrigeracionProducto`,
      {
        id_product,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Obtención de Transportista por cliente
export const obtenerTransportistaPorCliente = async (id_client) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/obtenerTransportistasPorCliente`,
      {
        id_client,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Obtención de Transportista por cliente
export const obtenerDireccionesPorShipper = async (id_shipper) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/obtenerDireccionesPorShipper`,
      {
        id_shipper,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Obtención de Transportista por cliente
export const obtenerPackingsPorCliente = async (id_client) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/obtenerPackingsPorCliente`,
      {
        id_client,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const listarPuertosTransbordo = async (tranferId) => {
  const { data } = await axios.get(
    `${RUTA_SERVIDOR_BACKEND}/listarPuertosTransbordo/${tranferId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data.data;
};

export const editarAgregarEliminarPuertoTransbordo = async (form) => {
  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/editarAgregarEliminarPuertoTransbordo`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data;
};

export const editarNombreTransbordo = async (form) => {
  const { data } = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/editarNombreTransbordoPorItinerario`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data.status;
};

export const eliminarTransbordo = async (id, idService) => {
  const { data } = await axios.delete(
    `${RUTA_SERVIDOR_BACKEND}/eliminarTransbordo/${id}-${idService}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data.status;
};

export const actualizarPuertosEmbarqueItinerario = async (form) => {
  const { data } = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/actualizarPuertosEmbarqueItinerario`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};

export const crearSolicitudDeModificacion = async (booking_itinerary_id) => {
  let dataResponse;
  let dataAux = new Array();

  store.state.loadingTableModal = true;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearSolicitudDeModificacion`,
      {
        booking_itinerary_id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const guardarSolicitudDeModificacion = async (data) => {
  let dataResponse;
  let dataAux = new Array();

  // store.state.loadingTableModal = true;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/guardarSolicitudDeModificacion`,
      {
        motivo: data.motivo,
        detalle: data.detalle,
        booking_itinerary_id: data.booking_itinerary_id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

// Información complementaria para solicitud de camb
export const verSolicitudDeModificacion = async (booking_modification_id) => {
  let dataResponse;
  let dataAux = new Array();

  store.state.loadingTableModal = true;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/verSolicitudDeModificacion`,
      {
        booking_modification_id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const editarPuertosTransbordosItinerario = async (form) => {
  const { data } = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/editarPuertosTransbordosItinerario`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data.status;
};

export const actualizarLateArrivalsPorBookingItinerario = async (form) => {
  const { data } = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/actualizarLateArrivalsPorBookingItinerario`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data.status;
};

// Solicitudes bookings
export const tomarSolicitud = async (booking_modification_id) => {
  const { data } = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/tomarSolicitud`,
    { booking_modification_id: booking_modification_id },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data.status;
};

export const aprobarSolicitud = async (form) => {
  const data = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/aprobarSolicitud`,
    {
      booking_modification_id: form.booking_modification_id,
      comment: form.comment,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data;
};

export const rechazarSolicitud = async (form) => {
  const data = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/rechazarSolicitud`,
    {
      booking_modification_id: form.booking_modification_id,
      comment: form.comment,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data;
};

export const cancelarReservaSolicitudModificacion = async (form) => {
  const data = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/cancelarReservaSolicitudModificacion`,
    {
      booking_modification_id: form.booking_modification_id,
      comment: form.comment,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data;
};

export const cambiarEstadoContenedorLateArrival = async (form) => {
  const { data } = await axios.put(
    `${RUTA_SERVIDOR_BACKEND}/cambiarEstadoDetalleLateArrivalsPorBookingItinerario`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data.status;
};

export const editarBooking = async (form) => {
  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/editarBooking`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data.status;
};

// cargar ver bookings
export const verBooking = async (id_booking) => {
  let dataResponse;
  let dataAux = new Array();
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/verBooking`,
      {
        id_booking,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });
  dataAux.push(dataResponse);

  return dataAux[0];
};
//data tracking tracking
export const getTrackingData = async (bi_id) => {
  let dataResponse = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/embarked/getTrackingData`,
    {
      booking_itinerary_id: bi_id
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
  ).then(function ({ data }) {
    dataResponse = data;
  }).catch(({ response }) => {
    dataResponse = response.data;
  });

  return dataResponse;
};
// cargar ver booking itineraries
export const verBookingItineraries = async (form) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/verBookingItinerary`,

      form,

      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });
  dataAux.push(dataResponse);

  return dataAux[0];
};
// Agregar Contenedores Late Arrival
export const guardarContenedorLateArrival = async (form) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/agregarLateArrival`,
      form,

      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const getBookingIdBycountry = async (idByCountry) => {
  try {
    const { status, data } = await axios.get(
      `${RUTA_SERVIDOR_BACKEND}/getBookingIdBycountry/${idByCountry}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return { status, data };
  } catch (error) {
    return { status: false, data: [] };
  }
};

export const obtenerConsignatariosYNotificados = async (id) => {
  try {
    const { status, data } = await axios.get(
      `${RUTA_SERVIDOR_BACKEND}/obtenerConsignatariosYNotificados/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return { status, data: data.data };
  } catch (error) {
    return { status: false, data: [] };
  }
};

// Obtener contenedores por itinerario
export const obtenerContenedoresPorItinerario = async (container_type) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/reservarAhora`,
      { container_type },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const listarAcuerdosLineasByIds = async (ids) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosLineasByIds`, ids, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const listarAcuerdosLineasByIdsNotRecharges = async (ids) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarAcuerdosLineasByIdsNotRecharges`, ids, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push(dataResponse);

  return dataAux[0];
};

export const buscarYRemplazarCount = async (form) => {
  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/buscarYRemplazarCount`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};

export const getContractsByNavId = async (form) => {

  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/getContractsByNavId`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return data;

};

export const buscarYReemplazar = async (form) => {
  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/buscarYReemplazar`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};

export const buscarYReemplazarClientesBaseCount = async (form) => {
  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/buscarYReemplazarClientesBaseCount`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};

export const buscarYReemplazarClientesBase = async (form) => {
  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/buscarYReemplazarClientesBase`,
    form,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};

export const bookingPorConfirmarEnvioEmail = (
  id_booking,
  booking_itinerary_id
) =>
  axios
    .get(
      `${RUTA_SERVIDOR_BACKEND}/enviarMailVerMisBookingsPorConfirmar/${id_booking}/${booking_itinerary_id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const bookingConfirmadosEnvioEmail = async (form) => {
  let response = [];

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/sendMailBookingConfirmado`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data, status }) => response.push({ data, status }))

    .catch(({ data, status }) => response.push({ data, status }));

  return response[0];
};

export const getSelectAndOptionsEmbarcador = async idClient => {
  const { data } = await axios.get(
    `${RUTA_SERVIDOR_BACKEND}/getSelectAndOptionsEmbarcador/${idClient}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};

export const getSemanasPorAnio = async anio => {
  const { data } = await axios.get(
    `${RUTA_SERVIDOR_BACKEND}/getSemanasPorAnio/${anio}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return data;
};

export const agregarRecargo = async form => {
  return await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/agregarRecargo`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
};

export const getRecharge = async id => {
  return await axios.get(`${RUTA_SERVIDOR_BACKEND}/getRecharge/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(({ data }) => data);
};

export const actualizarPlanificacionAnual = async (form) => {

  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/updateAnnualPlanning`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return data;
};


export const updateRecharge = async form => {
  return await axios.put(`${RUTA_SERVIDOR_BACKEND}/updateRecharge`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

//******************************planificacion semanal *************************//
//listar p semanal
export const getPlanificacionSemanal = async () => {
  let dataAux = new Array();
  await axios.get(`${RUTA_SERVIDOR_BACKEND}/listWeeklyPlanning`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};
//filtrar p semanal
export const filtrarPlanificacionSemanal = async (filters) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/listWeeklyPlanning`,
    {
      filters: filters
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};
//crear p semanl
export const crearPlanificacionSemanal = async (plans) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/storeWeeklyPlanning`,
    {
      plans: plans
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};
//editar p semanal
export const editarPlanificacionSemanal = async (plans, new_plans) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/updateWeeklyPlanning`,
    {
      plans: plans,
      new_plans: new_plans
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

//editar p semanal
export const cancelarPlanificacionSemanal = async (plans) => {
  let dataAux = new Array();
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/cancelWeeklyPlanning`,
    {
      plans: plans
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const getProductosPorContenedor = async (id_container) => {
  let dataAux = new Array();
  await axios.get(`${RUTA_SERVIDOR_BACKEND}/listProductsByContainer/${id_container}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    }).then(({ data }) => {
      dataAux = data;
    });
  return dataAux;
};

export const downloadReportePlanificacionSemanal = async (filters, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/reportWeeklyPlanning`,
    {
      filters: filters
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

export const deleteRecargo = async id => {
  return await axios.put(`${RUTA_SERVIDOR_BACKEND}/deleteRecargo/${id}`, null, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};


export const getRechargeFiltros = form => axios
  .post(`${RUTA_SERVIDOR_BACKEND}/listarRecargos`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const getRechargeTypes = async () => {
  return await axios.get(`${RUTA_SERVIDOR_BACKEND}/listarTiposRecargos`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const validarTiposRecargos = async code =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/validarTiposRecargos/${code}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const agregarTiposRecargos = async form =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/agregarTiposRecargos`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const actualizarTiposRecargos = async form =>
  axios.put(`${RUTA_SERVIDOR_BACKEND}/actualizarTiposRecargos`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const validarEliminarTiposRecargos = async id =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/validarEliminarTiposRecargos/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const eliminarTiposRecargos = async id =>
  axios.delete(`${RUTA_SERVIDOR_BACKEND}/eliminarTiposRecargos/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const getPlanificacionAnual = () =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/listAnnualPlanning`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(({ data }) => data);

export const eliminarPuertos = async form =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/deleteAnnualPlanningPorts`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const guardarPlanificacionAnual = async (form) => {

  const { data } = await axios.post(
    `${RUTA_SERVIDOR_BACKEND}/storeAnnualPlanning`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return data;
};

export const eliminarPuertosPrincipales = async form =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/deleteAnnualPlanning`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);


export const getPlantillaPlanificacionAnual = () =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/downloadAnnualPlanningTemplate`, {
    responseType: 'blob',
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then((resp) => resp);


export const importarPlantillaPlanificacionAnual = async (file) => {

  // Variable para mostrar loading
  store.state.uploadFileLoading = true;
  store.state.uploadFileLoadingError = { estado: false, message: '' };

  // Creación de un nuevo objeto formulario
  let dataForm = new FormData();

  // Se agrega el archivo file al formulario con el mismo nombre
  dataForm.append("uploaded_file", file);

  axios.post(`${RUTA_SERVIDOR_BACKEND}/importAnnualPlanning`, dataForm, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => {

    let { code, message } = data;

    if (code == 200) {

      let { message } = data;

      store.state.uploadFileLoadingError = { estado: false, message };
      store.state.uploadFileLoading = false;

    } else {

      store.state.uploadFileLoadingError = { estado: true, message };
      store.state.uploadFileLoading = false;

    }

  });
};

export const downloadReportePlanificacionAnual = async (filters, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/reportAnnualPlanning`,
    {
      filters: filters
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });
};

export const enablePSNotifications = (form) =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/enablePSNotifications`, form, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const listarConFiltros = (form) =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/listAnnualPlanning`, form, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(({ data }) => data);

//copiar real embarcado
export const copyFromRealEmbarked = (form) =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/copyFromRealEmbarked`, form, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

//copiar anio anterior
export const copyFromPreviousYear = (form) =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/copyFromPreviousYear`, form, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);




// Listar consignatarios por cliente
export const getConsignatariosPorCliente = (id_cliente) =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/listConsigneesByClient/${id_cliente}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(({ data }) => data);


// Listar consignatarios por cliente
export const getInfoBaseItinerary = () =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/infoBase`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(({ data }) => data);

export const getDepositosViasNavieras = async () => {
  const result = await axios.get(`${RUTA_SERVIDOR_BACKEND}/getDepositosViasNavieras`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return result;
}

export const changeItinerary = async form => {
  return await axios.put(`${RUTA_SERVIDOR_BACKEND}/changeItinerary`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const getItineraryDischargePorts = (form) =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/getItineraryDischargePorts`, form, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const getDischargePorts = async form => {
  return await axios.put(`${RUTA_SERVIDOR_BACKEND}/changeItinerary`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const downloadPdf = async form => {

  const date = new Date();
  const nameFile = 'BK_' + date.getFullYear() + '_' + (date.getMonth() + 1) + '_' + date.getDate() + '_' + form.id_by_country;

  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/getBookingItineraryPDF`, form,
    {
      responseType: 'blob',
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

  const blob = new Blob([data], { type: 'application/pdf' });

  let link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `${nameFile}.pdf`;
  link.click();
}

export const getItinerary = async id => {

  const { data } = await axios.get(`${RUTA_SERVIDOR_BACKEND}/itinerary/get/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return data;
};

export const deleteBookingItinerary = async id => {

  const { data } = await axios.delete(`${RUTA_SERVIDOR_BACKEND}/booking/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return data;
};

export const existModificationRequest = async id => {

  const { data } = await axios.get(`${RUTA_SERVIDOR_BACKEND}/existModificationRequest/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return data;
};

export const getItinerariosFilterReport = data =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarItinerarios`, {
      filters: data
    },
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const getReportTariffLine = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/tariff-line/export`, form,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const sendImportDataTariffLine = async form => {

  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/tariff-line/import`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return data;
};

export const importTariffRecharges = async form => {

  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/tariff-recharge/import`, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return data;
};

export const getMetodosPago = async () => {

  let dataAux;

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/getMetodosPago`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};



// Extra costos

export const getDataGeneralSelect = async (id) => {

  let dataAux;

  store.state.loadingTable = true;

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/${id}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
      store.state.loadingTable = false;
    })
    .catch(error => {
      console.error(error);
      store.state.loadingTable = false;
    });

  return dataAux;
};

export const validarNumeroContenedor = async (data) => {

  const { booking_number, container_number } = data;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/verificarNumeroContenedor`,
    {
      booking_number,
      container_number
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      store.state.lineas.dataNumeroContenedor = data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const getExtraCostos = async (data) => {

  store.state.lineas.isExtraCostosLoading = true;

  const { id_booking_itinerary, tipoCargo, tipoExtraCosto, tipoMoneda, neta, publica, tipoPago, tipoUnidad, tipoBL, isSearch, booking_number,
    tipoExtraCostoAsignado, idContenedor, tipoProveedor, isIVA } = data;

  let dataAux;


  await axios.post(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos`,
    {
      "id_booking_itinerary": id_booking_itinerary,
      "tipoCargo": tipoCargo,
      "tipoExtraCosto": tipoExtraCosto,
      "tipoMoneda": tipoMoneda,
      "neta": neta,
      "publica": publica,
      "tipoPago": tipoPago,
      "tipoUnidad": tipoUnidad,
      "tipoBL": tipoBL,
      "isSearch": isSearch,
      "booking_number": booking_number,
      "tipoExtraCostoAsignado": tipoExtraCostoAsignado,
      "idContenedor": idContenedor,
      "tipoProveedor": tipoProveedor,
      "isIVA": isIVA
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
      store.state.lineas.isExtraCostosLoading = false;
    })
    .catch(error => {
      console.error(error);
      store.state.lineas.isExtraCostosLoading = false;
    });

  return dataAux;
};

export const eliminarExtraCostos = async (id) => {

  let dataAux;

  await axios.delete(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/adminstracion/${id}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const mantenedorExtraCostos = async (data) => {

  let dataAux;

  const { id_extra_costo, id_tariff_recharges_unit_payments, id_proveedor, id_currency, neta, publica, id_sys_payment_method,
    isBL, id_booking_itinerary, id_usuario, comentarios, isIVA, container_number, bill_lading, booking_number,
    id_extra_costo_asignado, id_tipo_extra_costo, id_container_number, id_plant } = data;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/adminstracion`,
    {
      id_extra_costo,
      id_tariff_recharges_unit_payments,
      id_proveedor,
      id_currency,
      neta,
      publica,
      id_sys_payment_method,
      isBL,
      id_booking_itinerary,
      id_usuario,
      comentarios,
      isIVA,
      container_number,
      bill_lading,
      booking_number,
      id_extra_costo_asignado,
      id_tipo_extra_costo,
      id_container_number,
      id_plant
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const reporteGeneralExtraCostos = async (data) => {

  store.state.loadingTableModal = true;

  let rand = Math.floor(Math.random() * 99999999);


  const { fechaInicio, fechaTermino, tipoCargoModel, tipoExtraCostoModel, tipoMonedaModel, netaExactaModel, netaDesdeModel, netaHastaModel, publicaExactaModel, publicaDesdeModel,
    publicaHastaModel, tipoPagoModel, tipoUnidadModel, tipoBLModel } = data;


  await axios.post(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/reporteGeneralExtraCostos`,
    {
      fechaInicio: fechaInicio,
      fechaTermino: fechaTermino,
      tipoCargo: tipoCargoModel,
      tipoExtraCosto: tipoExtraCostoModel,
      tipoMoneda: tipoMonedaModel,
      netaExacta: netaExactaModel,
      netaDesde: netaDesdeModel,
      netaHasta: netaHastaModel,
      publicaExacta: publicaExactaModel,
      publicaDesde: publicaDesdeModel,
      publicaHasta: publicaHastaModel,
      tipoPago: tipoPagoModel,
      tipoUnidad: tipoUnidadModel,
      tipoBL: tipoBLModel
    },
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    })
    .then((response) => {

      let blob = new Blob([response.data], {
        type: ""
      });

      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `reporte-general-extra-costos${rand}.xlsx`;
      link.click();

      store.state.loadingTableModal = false;

    })
    .catch(error => {
      console.error(error);
      store.state.loadingTableModal = false;
    });

};



export const getTiposExtraCostos = async () => {

  let dataAux;

  store.state.lineas.isExtraCostosTipoLoading = true;

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/tiposExtraCostos`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
      store.state.lineas.isExtraCostosTipoLoading = false;
    })
    .catch(error => {
      console.error(error);
      store.state.lineas.isExtraCostosTipoLoading = false;
    });

  return dataAux;
};

export const validarTiposExtraCostos = async (data) => {

  const { nombre, codigo } = data;

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/validarTiposExtraCostos`,
    {
      nombre,
      codigo
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const mantenedorTiposExtraCostos = async (data) => {

  let dataAux;
  const { id, nombre, codigo, tipo_cargo, tipo_servicio, codigo_logistaas } = data;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/tiposExtraCostos`,
    {
      id,
      nombre,
      codigo,
      tipo_cargo,
      tipo_servicio,
      codigo_logistaas
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const eliminarTiposExtraCostos = async (id) => {

  let dataAux;

  await axios.delete(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/tiposExtraCostos/${id}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};



export const downloadExcelExtraCostos = id => {

  let rand = Math.floor(Math.random() * 99999999);

  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/reporteExtraCostos/${id}`,
      {
        responseType: "arraybuffer",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then((response) => {
      let blob = new Blob([response.data], {
        type: ""
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `reporte-extra-costos_${rand}.xlsx`;
      link.click();
    }).catch(error => {
      console.error("Error downloading report:", error);
    });

}

export const getTariffRechargeExport = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/tariff-recharge/export`, form,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const getTariffRechargeAddCodeNaviera = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/tariff-recharge/addcode`, form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const getTariffRechargeCodeNaviera = (id, idRechargeType) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/tariff-recharge/getcodes/${id}/${idRechargeType}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const deleteRechargeTypeNaviera = id =>
  axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/tariff-recharge/removecode/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const importQuotation = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/tariff-line/import-quotation`, form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .catch(({ response }) => response)
    .then(({ data }) => data);

export const getQuotationNavieras = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/tariff-recharge/get-quotation-navieras`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);


export const addImporterQuotation = payload =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/quotation-import`, payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const getQuotationImporters = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/quotation-import`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);


export const deleteQuotationImporters = id =>
  axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/quotation-import/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const getQuotation = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/quotation-import/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const updateQuotation = payload =>
  axios
    .put(`${RUTA_SERVIDOR_BACKEND}/quotation-import`, payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const getFiltersQuotation = () =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/quotation-import/filters`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getQuotationFilters = payload =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/quotation-import/index`, payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const generateQuotation = id =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/quotation-import/generate/${id}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const generateQuotationInit = () =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/quotation-import/init`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const generateQuotationAddDictionaryValue = payload =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/quotation-import/addDictionary`, payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);


export const getTariffRechargeTypes = () =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/tariff-recharge/recharges-types`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getTariffLineQuotationReport = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/quotation-import/generate-report-quotation/${id}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then((data) => data);


export const deleteRechargesByIds = payload =>
  axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/tariff-recharge/delete`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: payload
      })
    .then((data) => data);


export const GetDataProveedores = async data => {

  let dataAux;
  const { id_type_extra_cost, id_booking_itinerary , id_deposit } = data;

  const url = `${ (id_deposit && !isNaN(id_deposit)) ? '/' + id_deposit : "" }`;

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/dataProveedores/${id_booking_itinerary}/${id_type_extra_cost}${ url }`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const searchDataTypeExtraCost = ( idBookingItinerary , id_proveedor, id_tipo_extra_costo ) =>
  axios
  .get(`${RUTA_SERVIDOR_BACKEND}/lineas/extraCostos/search/${ idBookingItinerary }/${id_proveedor}/${id_tipo_extra_costo}`,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then( ( { data } ) => data ) ;

export const selectsRecharges = () =>
  axios
  .get(`${RUTA_SERVIDOR_BACKEND}/tariff-line/selects-recharges`,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then( ( { data : { data }} ) => data ) ;

export const tariffLineStorageRecharge = payload =>
  axios
  .post(`${RUTA_SERVIDOR_BACKEND}/tariff-line/storage-recharge-value`, payload,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then( ( { data : { data }} ) => data ) ;

//tracking bookings
export const getTrackingBookings = () =>

  axios.get(`${RUTA_SERVIDOR_BACKEND}/tracking/getTrackingBookings`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }).then(({ data }) => data);

//filtrar tracking bookings
export const getTrackingBookingsFiltered = async (filters) => {

  return axios.post(`${RUTA_SERVIDOR_BACKEND}/tracking/getTrackingBookings`,
    {
      filters: filters
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => data);

};

//reporte tracking
export const generateTrackingReport = async (data) => {

  return await axios.post(`${RUTA_SERVIDOR_BACKEND}/tracking/generateTrackingReport`,
    {
      filters: data
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => data);

};